import {
  JobAnalysisResponse,
  JobIndustryResponse,
} from '@doda/api-client/aspida/@types';
import { LinkList } from '../../LinkList';
import { nonNullableText } from '../createLinkList';

/**
 * 業種の関連リンクPropsを生成する
 * @param jobIndustryResponse
 * @param jobAnalysisResponse
 */
export const createIndustryLinkList = (
  jobIndustryResponse?: JobIndustryResponse,
  jobAnalysisResponse?: JobAnalysisResponse
): LinkList => ({
  separator: '＞',
  list: [
    {
      text: jobAnalysisResponse?.industryLName ?? '',
      href: jobIndustryResponse?.industryLURL ?? '',
    },
    {
      text: jobAnalysisResponse?.industrySName ?? '',
      href: jobIndustryResponse?.industrySURL ?? '',
    },
  ].filter(nonNullableText),
});
